"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../lib/utils";
import { inputCls } from "../../lib/styles";

type InputProps = InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      // Aus `inputCls`, nicht neben ihm: die Konstante und diese Komponente
      // beschrieben dasselbe Feld und liefen trotzdem auseinander (s. styles.ts).
      className={cn(
        inputCls,
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className
      )}
      {...props}
    />
  )
);
Input.displayName = "Input";

export { Input, type InputProps };
